(function($, Drupal) {

    var fnmMsg = Drupal.t("Please enter first name.");
    var fnmIMsg = Drupal.t("Invalid first name.");
    var lnmMsg = Drupal.t("Please enter last name.");
    var lnmIMsg = Drupal.t("Invalid last name.");
    var emlMsg = Drupal.t("Please enter email.");
    var emliMsg = Drupal.t("Please enter valid email.");
    var emliiMsg = Drupal.t("Invalid email address.");
    var ivldMsg = Drupal.t("Invalid message.");
    var tcMsg = Drupal.t("Please select the terms & condition.");
    var cptchMsg = Drupal.t("Please enter captcha.");
    var etnMsg = Drupal.t("Please enter correct telephone number.");
    var ivldcMsg = Drupal.t("Please enter valid captcha.");
    var htmltagMsg = Drupal.t("Please enter valid data. HTML tags are not allowed.");
    var onlyophMsg = Drupal.t("Please enter only alphabets.");
    var scontryMsg = Drupal.t("Please select country name.");
    var vlddataMsg = Drupal.t("Please enter valid data. You can only use following special charaters ~ ( ) _ . with alphanumeric value.");

    if(jQuery('.webform-submission-contact-form').length == 1){
        /*Add validations to validate field  */
        jQuery(".webform-submission-contact-form").validate({
            rules: {
				"first_name":{
                    required: true,
                    lettersonly: true,
                    disallow_tags:true,
				},
				"last_name":{
                    required: true,
                    lettersonly: true,
                    disallow_tags:true,
				},
                "confirm_email_address": {
                    required: true,
                    email: true,
                    check_mail_valid: true,
                    disallow_tags:true,
                },
                "message":{
                    disallow_tags: true,
                },
                "by_submitting_this_form_you_accept_our_terms_conditions_and_priv":{
                    required: true,
                },
                "captcha_response":{
                    captcha_required: true
                },
				
            },
            messages: {
                "first_name":{
                    required: fnmMsg,
                    disallow_tags: fnmIMsg
				},
				"last_name":{
                    required: lnmMsg,
                    disallow_tags: lnmIMsg
                },
                "confirm_email_address":{
                    required: emlMsg,
                    email: emliMsg,
                    disallow_tags: emliiMsg
                },
				"message":{
                    disallow_tags: ivldMsg
                },
                "by_submitting_this_form_you_accept_our_terms_conditions_and_priv":{
                    required: tcMsg
				},
				"captcha_response":{
                    captcha_required: cptchMsg
                },
            },
            errorPlacement: function(error, element) {
                if(element[0].name == "captcha_response")
                {
                    error.appendTo(element.parents("div.captcha"));
                }
                else {
                    error.appendTo(element.parents("div.form-item"));

                }
            },
            submitHandler: function (form) {
                jQuery(".form-item.form-group").removeClass("has-error");
                form.submit();
            },
            ignore: []
        });
		jQuery('form label.error').css('color', '#DE5781');
		

		/*Rule for  phone number Starts here*/
		jQuery.validator.addMethod('telephoneNumber', function (value, element) {
			return this.optional(element) || /^[0-9\.\-\+\ ]+$/.test(value);
		}, etnMsg);
	
		/*Rule for  email Starts here*/
		jQuery.validator.addMethod("check_mail_valid", function (value, element) {
			return this.optional(element) || /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i.test(value);
		}, emliMsg);
		/*Rule for  email ends here*/
	
		/*Rule for captcha Starts here*/
		jQuery.validator.addMethod("captcha_required", function (value, element) {
			var res = grecaptcha.getResponse();
			if(res == '') {
			   return false;
			} else {
			   return true;
			}
		}, ivldcMsg);
	
		/*Rule for  email Starts here*/
		jQuery.validator.addMethod("disallow_tags", function (value, element) {
		   return this.optional(element) || !/(<([^>]+)>)/ig.test(value);
		}, htmltagMsg);
	
		/*Rule for  email Starts here*/
		jQuery.validator.addMethod("allowed_valid_charecters", function (value, element) {
		   return this.optional(element) || /^[a-zA-Z0-9~()_ .]*$/ig.test(value);
		}, vlddataMsg);
	
        // Alphabets only validation
        jQuery.validator.addMethod("lettersonly", function(value, element) {
            return this.optional(element) || /^[a-z]+$/i.test(value);
          }, onlyophMsg); 

		//Code to set autocomplete correctly
		if (jQuery("input[autocomplete=chrome-off]").length > 0) {
			jQuery("input[autocomplete=chrome-off]").each(function(){
				jQuery(this).attr("autocomplete","off");
			});
		}
    }




    if(jQuery('#mid-disclaimer-form').length == 1){
        /*Add validations to validate field  */
        jQuery("#mid-disclaimer-form").validate({
            rules: {
				"choose_country":{
                    required: true,
                    disallow_tags:true,
				},				
            },
            messages: {
                "choose_country":{
                    required: scontryMsg,
				},
            },
            errorPlacement: function(error, element) {
                if(element[0].name == "captcha_response")
                {
                    error.appendTo(element.parents("div.captcha"));
                }
                else {
                    error.appendTo(element.parents("div.form-item"));

                }
            },
            submitHandler: function (form) {
                jQuery(".form-item.form-group").removeClass("has-error");
                form.submit();
            },
            ignore: []
        });
		jQuery('form label.error').css('color', '#DE5781');
		

		/*Rule for  phone number Starts here*/
		jQuery.validator.addMethod('telephoneNumber', function (value, element) {
			return this.optional(element) || /^[0-9\.\-\+\ ]+$/.test(value);
		}, etnMsg);
	
		/*Rule for  email Starts here*/
		jQuery.validator.addMethod("check_mail_valid", function (value, element) {
			return this.optional(element) || /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i.test(value);
		}, emliMsg);
		/*Rule for  email ends here*/
	
		/*Rule for captcha Starts here*/
		jQuery.validator.addMethod("captcha_required", function (value, element) {
			var res = grecaptcha.getResponse();
			if(res == '') {
			   return false;
			} else {
			   return true;
			}
		}, ivldcMsg);
	
		/*Rule for  email Starts here*/
		jQuery.validator.addMethod("disallow_tags", function (value, element) {
		   return this.optional(element) || !/(<([^>]+)>)/ig.test(value);
		}, htmltagMsg);
	
		/*Rule for  email Starts here*/
		jQuery.validator.addMethod("allowed_valid_charecters", function (value, element) {
		   return this.optional(element) || /^[a-zA-Z0-9~()_ .]*$/ig.test(value);
		}, vlddataMsg);
	
		//Code to set autocomplete correctly
		if (jQuery("input[autocomplete=chrome-off]").length > 0) {
			jQuery("input[autocomplete=chrome-off]").each(function(){
				jQuery(this).attr("autocomplete","off");
			});
		}
    }

})(jQuery, Drupal);